import { DefaultRenderPathResolver } from '../DefaultRenderPathResolver.js';
import { HtmlVideoPath } from './HtmlVideoRenderPath.js';
export function createDefaultVideoRenderPaths() {
    return [new HtmlVideoPath()];
}
export function createVideoRenderPathResolver(paths = createDefaultVideoRenderPaths()) {
    return new DefaultRenderPathResolver(paths);
}
